import { Plan } from "@readyfit-common/models";
import { WorkoutFormValues } from "src/grading/components/EditWorkoutModal/EditWorkoutModal";
import { convertMinuteStringToTotalMinutes } from "./timeUtils";

export const parseRunWorkout = (
  workout: WorkoutFormValues,
  date?: string,
  isTemplate?: boolean,
) => {
  const { name, workoutCategoryId, workoutTypeId, distance, description } =
    workout;
  return {
    name,
    workoutCategoryId,
    workoutTypeId,
    distance: Number(distance),
    description,
    ...(date && !isTemplate && { date }),
  };
};

export const parseSwimWorkout = (
  workout: WorkoutFormValues,
  date?: string,
  isTemplate?: boolean,
) => {
  const { name, workoutCategoryId, workoutTypeId, distance, description } =
    workout;
  return {
    name,
    workoutCategoryId,
    workoutTypeId,
    distance: Number(distance),
    description,
    ...(date && !isTemplate && { date }),
  };
};

export const parseFitnessWorkout = (
  workout: WorkoutFormValues,
  date?: string,
  isTemplate?: boolean,
) => {
  const {
    name,
    workoutCategoryId,
    workoutTypeId,
    distance,
    description,
    estimatedTime,
  } = workout;
  return {
    name,
    workoutCategoryId,
    workoutTypeId,
    distance: Number(distance),
    description,
    estimatedTime: convertMinuteStringToTotalMinutes(estimatedTime || ""),
    ...(date && !isTemplate && { date }),
    exercises: workout.exercises?.map((exercise) => {
      return {
        name: exercise.name,
        sets: Number(exercise.sets),
        reps: Number(exercise.reps),
        description: exercise.description,
      };
    }),
  };
};

export const getWeeksForPlan = (plan: Plan) => {
  return plan.phases[0].weeks;
};
